import { nanoid } from "@reduxjs/toolkit";
import { useToast } from "fds";
import { useTranslation } from "react-i18next";
import { useRef, useCallback } from "react";

export default function useStartDownload() {
  const toast = useToast();
  const { t } = useTranslation();

  const startedRef = useRef(false);

  const startDownload = useCallback(
    (loaded: number) => {
      if (startedRef.current) return;

      if (loaded > 50_000_000) {
        startedRef.current = true;
        toast.toastMsg(nanoid(), t("file.alert.downloadBigFile"), "success");
      }
    },
    [toast, t]
  );

  const resetStartDownload = useCallback(() => {
    startedRef.current = false;
  }, []);

  return { startDownload, resetStartDownload };
}
